export enum CategoryChoice {
    TEXT = "Texto",
    IMAGE = "Imagen",
    VIDEO = "Video",
    AUDIO = "Audio"
}

export enum TaskType {
    FILL_MASK,
    QNA,
    SUMMARY,
    TABLE_QNA,
    TEXT_CLASS,
    TEXT_GEN,
    TEXT2TEXT_GEN,
    TOKEN_CLASS,
    TRANSLATION,
    ZERO_SHOT_CLASS,
    OBJECT_DETECTION,
    IMAGE_CLASS,
    SUPER_RESOLUTION,
    IMAGE_SEGMENTATION,
    QUESTION_GENERATION
}

const taskType2Str = new Map<TaskType, string>();
// TODO: Refactor this.
// Use the appropiate field for class and English translation
taskType2Str[TaskType.FILL_MASK] = { en: "fill-mask", es: "Completar Máscara" };
taskType2Str[TaskType.QNA] = { en: "question-answering", es: "Preguntas-Respuestas" };
taskType2Str[TaskType.SUMMARY] = { en: "summary", es: "Resumen" };
taskType2Str[TaskType.TABLE_QNA] = { en: "table-qna", es: "Preguntas sobre tablas" };
taskType2Str[TaskType.TEXT_CLASS] = { en: "text-classification", es: "Clasificación de texto" };
taskType2Str[TaskType.TEXT_GEN] = { en: "text-generation", es: "Generación de textos" };
taskType2Str[TaskType.TEXT2TEXT_GEN] = { en: "text2text-generation", es: "Generación Texto-Texto" };
taskType2Str[TaskType.TOKEN_CLASS] = { en: "token-classification", es: "Clasificación de token" };
taskType2Str[TaskType.TRANSLATION] = { en: "translation", es: "Traducción" };
taskType2Str[TaskType.ZERO_SHOT_CLASS] = { en: "zero-shot-class", es: "Clasificación Zero-Shot" };
taskType2Str[TaskType.OBJECT_DETECTION] = { en: "obj-detection", es: "Detección de objetos" };
taskType2Str[TaskType.IMAGE_CLASS] = { en: "img-classification", es: "Clasificación de imágenes" };
taskType2Str[TaskType.SUPER_RESOLUTION] = { en: "super-resolution", es: "Super resolución" };
taskType2Str[TaskType.IMAGE_SEGMENTATION] = { en: "img-segmentation", es: "Segmentación de imágenes" };
taskType2Str[TaskType.QUESTION_GENERATION] = { en: "question-answering", es: "Generación de preguntas" };

export class ServiceItem {
    constructor(
        public id: number,
        public category: CategoryChoice,
        public name: string,
        public description: string,
        public longDescription: string,
        public url: string,
        public invocationsCount: number,
        public taskType: TaskType,
        public codeSample: string,
        public status: string = ''
    ) { }

    public strTaskType(): any {
        return taskType2Str[this.taskType];
    }

    public deploymentStatus(): string {
        const isDeployed = this.url.indexOf('localhost') === -1
        return isDeployed ? 'listo' : 'pendiente'
    }
}

export class Customer {
    fullname: string;
    country: string;
    phoneNumber: string;
    address: string;
    linkedinUrl: string;
    twitterUrl: string;
    email: string;
}

export class Project {
    customer: string;
    name: string;
}

export class ServiceTask {
    constructor(
        public category: CategoryChoice,
        public taskType: TaskType,
        public title: string,
        public description: string
    ) { }

    public strTaskType(): any {
        return taskType2Str[this.taskType];
    }
}

export class ImageInfo {
    constructor(
        public caption: string,
        public imagePath: string
    ) { }
}
